import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from 'rsuite';
import Link from '../Link';

const LinkIconButton = ({ icon, ...restProps }) => (
  <IconButton
    {...restProps}
    icon={<Icon icon={icon} style={{ width: 36 }} />}
    appearance="link"
    style={{ width: 36, top: -8 }}
  />
);

LinkIconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.string,
  disabled: PropTypes.bool
};

LinkIconButton.defaultProps = {
  size: 'sm',
  disabled: false
};

const IconLink = ({ icon, size, disabled, ...restProps }) =>
  disabled ? (
    <LinkIconButton icon={icon} size={size} disabled={disabled} />
  ) : (
    <Link {...restProps}>
      <LinkIconButton icon={icon} size={size} disabled={disabled} />
    </Link>
  );

IconLink.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.string,
  disabled: PropTypes.bool
};

IconLink.defaultProps = {
  size: 'sm',
  disabled: false
};

export default IconLink;
